import React from 'react'
import { T } from 'components/components/i18n'
import Product from './Product'
import RimProduct from './RimProduct'
import Pagination from '../Pagination'
import SortBy from '../SortBy'
import PriceOptions from '../PriceOptions'
import CATEGORIES from '../../../../../helpers/categories'
import styles from './styles.less'
import CompleteWheelProduct from './CompleteWheelProduct'
import { Row, Col } from 'react-bootstrap'

export const ProductsList = (props) => {
  const {
    onSortByClick,
    onPageClick,
    selectedSortOption,
    shop,
    pagination,
    topRank,
    products,
    isPair,
    category,
    sortBy,
    initialSearchDone
  } = props

  let productComponents, topRankSection, topRankComponents, paginationComponent, resultsHeader
  if (!initialSearchDone)
    return null
  if (initialSearchDone && products.length === 0 && topRank.length === 0) {
    productComponents = <h4 className={styles.noResults}><T id="Hittade inga produkter för din sökning" /></h4>
  } else {
    let className, productColumns, hasCampaignText = false
    productComponents = []
    topRankComponents = []
    switch(category.id) {
      case CATEGORIES.RIM.id:
        productComponents = products.map(product => <RimProduct product={product} key={product.id}/>)
        className = styles.flexWrapFourColumns
        productColumns = styles.fourColumns
        break
      case CATEGORIES.COMPLETE_WHEEL.id:
        productComponents = products.map(product => (
          <CompleteWheelProduct product={product} isPair={isPair} key={product.id} />
        ))
        if (isPair) {
          className = styles.flexWrap
          productColumns = styles.twoColumns
        } else {
          className = styles.flexWrapFourColumns
          productColumns = styles.fourColumns
        }
        break
      default:
        productComponents = products.map(product => <Product product={product} isPair={isPair} key={product.id}/>)
        if (topRank.length) {
          const anyLabel2Exists = [1, 2, 3].some(position => {
            const hasText = shop.topBrandsConfig?.['top_brands']?.[position]?.label2?.trim()
            const hasProduct = (topRank.filter(item => item?.rank?.group === position))?.length > 0
            return hasProduct && hasText
          });
          Array.from([1, 2, 3]).forEach(position => {
            const product = topRank.filter(item => item?.rank?.group === position)
            const _placeholder = shop.topBrandsConfig?.['top_brands']?.[position]?.placeholder
            const placeholder = _placeholder ? _placeholder.split(',').find(part => part.trim().startsWith('http')) : undefined
            if (product?.length > 0) {
              const label1 =shop.topBrandsConfig?.['top_brands']?.[position]?.label1 || ''
              const rawLabel2 = shop.topBrandsConfig?.['top_brands']?.[position]?.label2 || '';
              const label2 = rawLabel2 || (anyLabel2Exists ? '\u00A0' : '')
              if (label1 || label2) {
                hasCampaignText = true
              }
              topRankComponents.push(
                <Product
                  key={product[0].id}
                  product={product[0]}
                  isPair={isPair}
                  campaignLabel1={label1}
                  campaignLabel2={label2}
                  isTopRank={true}
                />
              )
            } else if (placeholder) {
              // TODO: validate valid url
              topRankComponents.push(
                <li
                  className={`${styles.placeholder} staggered-top-rank`}
                  style={{backgroundImage: `url(${placeholder})`}}
                ></li>
              )
            }
          })
        }

        if (isPair) {
          className = styles.flexWrap
          productColumns = styles.twoColumns
        } else {
          className = styles.flexWrapFourColumns
          productColumns = styles.fourColumns
        }
    }

    if (topRankComponents.length) {
      const campaignCSS = hasCampaignText ? styles.campaignText : ''
      topRankSection = (
        <div className={`topRankColumnsContainer ${styles.topRankColumnsContainer}`}>
          <ul
            className={`${campaignCSS} list-unstyled ${styles.flexWrap} ${styles.topRankColumns}`}
            key={`topRank-${topRank.length}-${sortBy}-${topRank[0] && topRank[0].id}-${topRank[topRank.length - 1] && topRank[topRank.length - 1].id}`}
          >
            {topRankComponents}
          </ul>
        </div>
      )
    }

    productComponents = (
      <ul
        className={`list-unstyled ${className} ${productColumns}`}
        key={`${products.length}-${sortBy}-${products[0] && products[0].id}-${products[products.length - 1] && products[products.length - 1].id}`}
      >
        {productComponents}
      </ul>
    )

    paginationComponent = (
      <Pagination
        pagination={pagination}
        shop={shop}
        onPageClick={onPageClick}
      />
    )

    resultsHeader = (
      <Row className={styles.productsListHeader}>
        <Col md={3} sm={12} xs={12}><SortBy onSortByClick={onSortByClick} selectedSortOption={selectedSortOption}/></Col>
        <Col md={9} sm={12} xs={12} className={`${styles.priceOptions} productList_priceOptions`}><PriceOptions /></Col>
      </Row>
    )
  }

  return (
    <div className="products-list">
      {resultsHeader}
      {topRankSection}
      {productComponents}
      {paginationComponent}
    </div>
  )
}

export default ProductsList
